
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { SuccessIcon } from "../components";

@Component({
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    AmSpacing,
    AmButton,
    SuccessIcon
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: object;
}
